import { Component } from '@angular/core';

@Component({
  selector: 'lib-close-icon',
  standalone: true,
  imports: [],
  templateUrl: './close-icon.component.html',
  styleUrl: './close-icon.component.css',
})
export class CloseIconComponent {}
